import React from "react";
import { Link } from "react-router-dom";
import "../../css/about.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";

const PLEDGE_ITEM_KEYS = ["item1", "item2", "item3", "item4"];

function PledgeCheckIcon() {
  return (
    <svg
      className="w-5 h-5 text-[ $shareColor]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 13l4 4L19 7"
      />
    </svg>
  );
}

const About = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Header />
      <main className="about-page">
        <div className="about-content">
          <section className="about-hero" aria-label={t("aboutPage.hero.aria")}>
            <div className="about__container">
              <nav
                className="about__breadcrumb"
                aria-label={t("aboutPage.hero.breadcrumbAria")}
              >
                <Link to="/" className="about__breadcrumb-link">
                  {t("aboutPage.hero.breadcrumb")}
                </Link>
              </nav>
              <h1 className="about__title">
                <span className="about__title-prefix">
                  {t("aboutPage.hero.titlePrefix")}
                </span>{" "}
                <span className="about__title-brand">
                  {t("aboutPage.hero.titleBrand")}
                </span>
              </h1>
              <p className="about__text">{t("aboutPage.hero.text")}</p>
            </div>
          </section>

          <section className="pledge" aria-label={t("aboutPage.pledge.aria")}>
            <div className="pledge__container">
              <h2 className="pledge__title">{t("aboutPage.pledge.title")}</h2>
              <div className="pledge__grid">
                {PLEDGE_ITEM_KEYS.map((key) => (
                  <div key={key} className="pledge-card">
                    <div className="pledge-card__icon">
                      <PledgeCheckIcon />
                    </div>
                    <div className="pledge-card__body">
                      {t(`aboutPage.pledge.${key}`)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>

        <section className="why" aria-label={t("aboutPage.why.aria")}>
          <div className="why__container">
            <h2 className="why__title">{t("aboutPage.why.title")}</h2>
            <p className="why__text">{t("aboutPage.why.text")}</p>
            <div className="why__grid">
              <div className="why-card">
                <div className="why-card__icon">
                  <svg
                    className="w-8 h-8"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23.693L5 14.5m14.8.8l.8 2a.75.75 0 01-.548 1.022l-4.078.68a.75.75 0 00-.532.384l-.683 1.282a.75.75 0 01-1.518 0l-.683-1.282a.75.75 0 00-.532-.384l-4.078-.68a.75.75 0 01-.548-1.022l.8-2"
                    />
                  </svg>
                </div>
                <div className="why-card__title">
                  {t("aboutPage.why.card1Title")}
                </div>
                <div className="why-card__desc">
                  {t("aboutPage.why.card1Desc")}
                </div>
              </div>

              <div className="why-card">
                <div className="why-card__icon">
                  <svg
                    className="w-8 h-8"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
                    />
                  </svg>
                </div>
                <div className="why-card__title">
                  {t("aboutPage.why.card2Title")}
                </div>
                <div className="why-card__desc">
                  {t("aboutPage.why.card2Desc")}
                </div>
              </div>

              <div className="why-card">
                <div className="why-card__icon">
                  <svg
                    className="w-8 h-8"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
                    />
                  </svg>
                </div>
                <div className="why-card__title">
                  {t("aboutPage.why.card3Title")}
                </div>
                <div className="why-card__desc">
                  {t("aboutPage.why.card3Desc")}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default About;
